import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import config from "../../Config";
import FeeSystemMenu from "./FeeSystemMenu";

const EditChallan = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [UserName] = useState(localStorage.getItem("UserName") || "");

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  /* Challan numbers may include "N" + student id (e.g. 260402N4425) when no registration no — not a parsing bug. */
  const rawChallan =
    params.get("ChallanNo") ||
    params.get("challanNo") ||
    params.get("Challan_No") ||
    "";
  let challanNoParam = "";
  try {
    challanNoParam = rawChallan ? decodeURIComponent(rawChallan).trim() : "";
  } catch {
    challanNoParam = rawChallan.trim();
  }

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [challan, setChallan] = useState(null);
  const [items, setItems] = useState([]);
  const [originalItems, setOriginalItems] = useState([]);
  const [feeTypes, setFeeTypes] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [afterDueDate, setAfterDueDate] = useState("");
  const [concessionRule, setConcessionRule] = useState(null);

  useEffect(() => {
    document.title = "Edit Challan";
  }, []);

  useEffect(() => {
    if (!challanNoParam) {
      toast.error("Challan number is missing.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setLoading(true);
    const data = {
      AccessKey,
      UserID,
      MemberType,
      Challan_No: challanNoParam,
    };

    axios({
      method: "post",
      url: config.base_url + "ADLedger/GetChallanForEdit",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setChallan(response.data.Challan);
          setItems(response.data.Items || []);
          setOriginalItems(response.data.Items || []);
          setConcessionRule(response.data.ConcessionRule || null);
          if (response.data.Challan?.Due_Date) {
            setDueDate(response.data.Challan.Due_Date.substring(0, 10));
          }
          if (response.data.Challan?.After_Due_Date) {
            setAfterDueDate(response.data.Challan.After_Due_Date.substring(0, 10));
          }
        } else {
          toast.error(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  }, [AccessKey, UserID, MemberType, challanNoParam]);

  useEffect(() => {
    const apiData = {
      AccessKey,
      UserID,
      MemberType,
      PageNo: 1,
      PageSize: 200,
      SchoolID: 1,
    };

    axios({
      method: "post",
      url: config.base_url + "FeeType/GetFeeTypes",
      headers: { "Content-Type": "application/json" },
      data: apiData,
    })
      .then((response) => {
        setFeeTypes(response.data.ListofRecords || []);
      })
      .catch(() => {});
  }, [AccessKey, UserID, MemberType]);

  const handleItemChange = (index, field, value) => {
    setItems((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [field]: value } : row))
    );
  };

  const handleFeeCodeChange = (index, value) => {
    const fee = feeTypes.find((ft) => String(ft.Fee_Type_Code) === String(value));
    setItems((prev) =>
      prev.map((row, i) =>
        i === index
          ? {
              ...row,
              FeeCode: value,
              Description: fee ? fee.Fee_Type_Name : row.Description,
            }
          : row
      )
    );
  };

  const handleAddRow = () => {
    setItems((prev) => [...prev, { FeeCode: "", Description: "", Amount: 0 }]);
  };

  const handleRemoveRow = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    if (!challanNoParam) return;
    const cleaned = items
      .map((row) => ({
        FeeCode: (row.FeeCode || "").toString().trim(),
        Description: row.Description || "",
        Amount: parseFloat(row.Amount) || 0,
        ConcessionCode: row.ConcessionCode || "",
        ConcessionAmount: parseFloat(row.ConcessionAmount) || 0,
        Arrears: parseFloat(row.Arrears) || 0,
      }))
      .filter((row) => row.FeeCode && row.Amount > 0);

    if (cleaned.length === 0) {
      toast.error("Please add fee details.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setSaving(true);
    axios({
      method: "post",
      url: config.base_url + "ADLedger/UpdateChallanForEdit",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        UserName,
        Challan_No: challanNoParam,
        Due_Date: dueDate ? `${dueDate}T00:00:00` : null,
        After_Due_Date: afterDueDate ? `${afterDueDate}T00:00:00` : null,
        Items: cleaned,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
        } else {
          toast.error(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
        }
        setSaving(false);
      })
      .catch(() => {
        setSaving(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const totalAmount = items.reduce(
    (sum, row) => sum + (parseFloat(row.Amount) || 0),
    0
  );
  const originalTotalAmount = originalItems.reduce(
    (sum, row) => sum + (parseFloat(row.Amount) || 0),
    0
  );

  const isPaid = challan?.Is_Paid === true;

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/FeeSystem/PrintVouchers">Print Vouchers</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Challan
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Challan</div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" role="status"></Spinner>
            </div>
          ) : (
            <>
              {challan && (
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <strong>Challan No:</strong> {challan.Challan_No}
                      </div>
                      <div className="col-md-4">
                        <strong>Student:</strong> {challan.Student_Name}
                      </div>
                      <div className="col-md-4">
                        <strong>Status:</strong> {isPaid ? "Paid" : "Unpaid"}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-4">
                        <label className="form-label">Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={dueDate}
                          onChange={(e) => setDueDate(e.target.value)}
                          disabled={isPaid}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">After Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={afterDueDate}
                          onChange={(e) => setAfterDueDate(e.target.value)}
                          disabled={isPaid}
                        />
                      </div>
                    </div>
                    {concessionRule && (
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <strong>Concession Rule:</strong>{" "}
                          {concessionRule.Concession_Rule_Code}{" "}
                          {concessionRule.Concession_Rule_Name
                            ? `- ${concessionRule.Concession_Rule_Name}`
                            : ""}{" "}
                          {concessionRule.Concession_Percentage > 0
                            ? `(${concessionRule.Concession_Percentage}%)`
                            : ""}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {isPaid && (
                <div className="alert alert-warning">
                  Paid challan cannot be edited.
                </div>
              )}

              <div className="card">
                <div className="card-body">
                  <div className="mb-3">
                    <h6 className="mb-2">Existing Fee Details</h6>
                    <table className="table table-theme">
                      <thead>
                        <tr>
                          <th>Fee Code</th>
                          <th>Description</th>
                          <th>Amount</th>
                        <th>Concession Code</th>
                        <th>Concession Amount</th>
                        <th>Arrears</th>
                        </tr>
                      </thead>
                      <tbody>
                        {originalItems.map((row, index) => (
                          <tr key={`orig-${index}`}>
                            <td>{row.FeeCode}</td>
                            <td>{row.Description}</td>
                            <td>{row.Amount}</td>
                          <td>{row.ConcessionCode}</td>
                          <td>{row.ConcessionAmount}</td>
                          <td>{row.Arrears}</td>
                          </tr>
                        ))}
                        {originalItems.length === 0 && (
                          <tr>
                          <td colSpan={6} className="text-center">
                              No fee details.
                            </td>
                          </tr>
                        )}
                        {originalItems.length > 0 && (
                          <tr>
                          <td colSpan={2} className="text-end">
                              <strong>Total</strong>
                            </td>
                            <td>
                              <strong>{originalTotalAmount}</strong>
                            </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <h6 className="mb-2">New Fee Details</h6>
                  <table className="table table-theme">
                    <thead>
                      <tr>
                        <th>Fee Code</th>
                        <th>Description</th>
                        <th>Amount</th>
                        <th>Concession Code</th>
                        <th>Concession Amount</th>
                        <th>Arrears</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <select
                              className="form-select"
                              value={row.FeeCode || ""}
                              onChange={(e) => handleFeeCodeChange(index, e.target.value)}
                              disabled={isPaid}
                            >
                              <option value="">Select</option>
                              {feeTypes.map((ft) => (
                                <option key={ft.Fee_Type_ID} value={ft.Fee_Type_Code}>
                                  {ft.Fee_Type_Code} - {ft.Fee_Type_Name}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row.Description || ""}
                              onChange={(e) =>
                                handleItemChange(index, "Description", e.target.value)
                              }
                              disabled={isPaid}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.Amount || 0}
                              onChange={(e) =>
                                handleItemChange(index, "Amount", e.target.value)
                              }
                              disabled={isPaid}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={row.ConcessionCode || ""}
                              onChange={(e) =>
                                handleItemChange(index, "ConcessionCode", e.target.value)
                              }
                              disabled={isPaid}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.ConcessionAmount || 0}
                              onChange={(e) =>
                                handleItemChange(index, "ConcessionAmount", e.target.value)
                              }
                              disabled={isPaid}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={row.Arrears || 0}
                              onChange={(e) =>
                                handleItemChange(index, "Arrears", e.target.value)
                              }
                              disabled={isPaid}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="button button-danger button-sm"
                              onClick={() => handleRemoveRow(index)}
                              disabled={isPaid}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                      {items.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No fee details.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <button
                        type="button"
                        className="button button-secondary"
                        onClick={handleAddRow}
                        disabled={isPaid}
                      >
                        Add Fee Head
                      </button>
                    </div>
                    <div>
                      <strong>Total: </strong> {totalAmount}
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <button
                      type="button"
                      className="button button-primary"
                      onClick={handleSave}
                      disabled={isPaid || saving}
                    >
                      {saving ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default EditChallan;
